module.exports = __webpack_public_path__ + "static/img/VS1.ea24b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VS1.jpg
// module id = nl+g
// module chunks = 1